import createUserOperationAPI from './user-apis';
import createMallOperationAPI from './mall-apis';
import createAdOperationAPI from './ad-apis';
import createAxios from './_APITool';

class API {
  static auth = null;

  static mall = null;

  static ad = null;

  static axiosInstance = null;

  static #instance = null;

  static userName = '';

  static get instance() {
    if (!this.#instance) {
      this.#instance = new API();
    }
    if (!this.#instance.axiosInstance) {
      this.#instance.axiosInstance = createAxios('https://api.powerai.com.tw/');
      // this.#instance.axiosInstance = createAxios('https://localhost:5102');

      this.#instance.axiosInstance.interceptors.response.use((res) => res, (error) => {
        if (error?.response?.status === 401) {
          window.location.href = '/';
        }

        return Promise.reject(error);
      });
    }

    const existingAccessToken = localStorage.getItem('access_Token');
    if (existingAccessToken) {
      this.#instance.axiosInstance.defaults.headers.common.Authorization = existingAccessToken;
    }
    if (!this.#instance.auth) {
      this.#instance.auth = createUserOperationAPI(this.#instance.axiosInstance);
    }
    if (!this.#instance.mall) {
      this.#instance.mall = createMallOperationAPI(this.#instance.axiosInstance);
    }
    if (!this.#instance.ad) {
      this.#instance.ad = createAdOperationAPI(this.#instance.axiosInstance);
    }
    return this.#instance;
  }
}

export default API.instance;
